import React from "react";
import '../css/Home.css'
// import { FaGreaterThan } from "react-icons/fa";
import { Link } from "react-router-dom";

const TopSection = ({ title, breadcrumb }) => {
  return (
    <section className="setting-section text-white">
      <div className="container py-5">
        <h2 className="fw-bold">{title}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to='/' className="text-white text-decoration-none">Home</Link>
            </li>
           
            <li className="breadcrumb-item active text-white" aria-current="page">
              {breadcrumb}
            </li>
          </ol>
        </nav>
      </div>
    </section>
  );
};

export default TopSection;